class DelSofaMetaLanding {
  constructor(root) {
    this.root = root;
    this.triggers = [...root.querySelectorAll('[data-dsm-lightbox-trigger]')];
    this.dialog = root.querySelector('[data-dsm-lightbox]');
    this.activeIndex = 0;
    this.lastTrigger = null;
    this.initReveal();
    this.initGallery();
    this.initMeta();
    this.initStickyCta();
  }

  initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    this.root.querySelectorAll('.dsm-reveal').forEach((element) => observer.observe(element));
  }

  initGallery() {
    if (!this.dialog || !this.triggers.length || typeof this.dialog.showModal !== 'function') return;
    this.image = this.dialog.querySelector('figure img');
    this.caption = this.dialog.querySelector('figcaption');
    this.triggers.forEach((trigger, index) => trigger.addEventListener('click', () => this.open(index, trigger)));
    this.dialog.querySelector('[data-dsm-lightbox-close]').addEventListener('click', () => this.dialog.close());
    this.dialog.querySelector('[data-dsm-lightbox-prev]').addEventListener('click', () => this.show(this.activeIndex - 1));
    this.dialog.querySelector('[data-dsm-lightbox-next]').addEventListener('click', () => this.show(this.activeIndex + 1));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.show(this.activeIndex - 1);
      if (event.key === 'ArrowRight') this.show(this.activeIndex + 1);
    });
    this.dialog.addEventListener('close', () => this.lastTrigger?.focus());
  }

  open(index, trigger) {
    this.lastTrigger = trigger;
    this.show(index);
    this.dialog.showModal();
  }

  show(index) {
    this.activeIndex = (index + this.triggers.length) % this.triggers.length;
    const source = this.triggers[this.activeIndex].querySelector('img');
    this.image.src = source.currentSrc || source.src;
    this.image.alt = source.alt;
    this.caption.textContent = source.alt;
  }

  initMeta() {
    const node = this.root.querySelector('[data-dsm-meta]');
    if (!node) return;
    try {
      const meta = JSON.parse(node.textContent);
      if (meta.title) document.title = meta.title;
      this.setMeta('name', 'description', meta.description);
      this.setMeta('property', 'og:type', 'product');
      this.setMeta('property', 'og:title', meta.title);
      this.setMeta('property', 'og:description', meta.description);
      this.setMeta('property', 'og:url', meta.url);
      this.setMeta('property', 'og:image', this.absoluteUrl(meta.image));
      this.setMeta('name', 'twitter:card', 'summary_large_image');
      this.setMeta('name', 'twitter:title', meta.title);
      this.setMeta('name', 'twitter:description', meta.description);
      this.setMeta('name', 'twitter:image', this.absoluteUrl(meta.image));
    } catch (error) {
      return;
    }
  }

  absoluteUrl(value) {
    if (!value) return '';
    if (value.startsWith('//')) return `${window.location.protocol}${value}`;
    return new URL(value, window.location.origin).href;
  }

  setMeta(attribute, key, value) {
    if (!value) return;
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, key);
      document.head.appendChild(element);
    }
    element.setAttribute('content', value);
  }

  initStickyCta() {
    const hero = this.root.querySelector('.dsm-hero');
    const stickyButton = this.root.querySelector('.dsm-mobile-cta');
    if (!hero || !stickyButton) return;
    if (!('IntersectionObserver' in window)) {
      this.root.classList.add('is-mobile-cta-visible');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      this.root.classList.toggle('is-mobile-cta-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0 });
    observer.observe(hero);
  }
}

const initDelSofaMeta = (scope = document) => {
  scope.querySelectorAll('[data-dsm-root]').forEach((root) => {
    if (!root.dataset.dsmReady) {
      root.dataset.dsmReady = 'true';
      new DelSofaMetaLanding(root);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initDelSofaMeta());
} else {
  initDelSofaMeta();
}

document.addEventListener('shopify:section:load', (event) => initDelSofaMeta(event.target));
